import React, { useState } from "react";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  useLoadScript,
} from "@react-google-maps/api";
import InfoWindowContent from "./InfoWindowContent";
import CustomLoading from "../utils/CustomLoading";

// Move the libraries array outside the component to make it static
const libraries = ["marker"];

const mapContainerStyle = {
  height: "calc(100vh - 180px)",
  width: "100%",
  minHeight: "400px",
};

const DynamicMap = ({ locations, centerPoint }) => {
  const [hoveredLocation, setHoveredLocation] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const defaultCenter = {
    lat: centerPoint?.lat || 21.146633, // Latitude for India's approximate center
    lng: centerPoint?.lng || 79.08886, // Longitude for India's approximate center
  };

  // Use the libraries constant directly in useLoadScript
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY, // Your API Key
    libraries: libraries, // Use the constant here
  });

  if (loadError) return <div>Error loading maps</div>;

  if (!isLoaded) {
    // Show loader while the API is being loaded
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CustomLoading /> {/* Replace with your loader */}
      </div>
    );
  }

  return (
    <>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={7}
        center={locations[0] || defaultCenter}
        options={{
          mapTypeControl: false, // Disable map and satellite view options
          streetViewControl: false,
        }}
      >
        {locations.map((location, index) => (
          <Marker
            key={index}
            position={{
              lat: location.latitude || location.lat,
              lng: location.longitude || location.lng,
            }}
            onClick={() => setSelectedLocation(location)}
            icon={{
              url: "/factory.svg",
              scaledSize: new window.google.maps.Size(40, 40), // Resize SVG icon
              anchor: new window.google.maps.Point(20, 40), // Adjust anchor point
            }}
          />
        ))}
        {centerPoint && (
          <Marker
            position={{ lat: centerPoint.lat, lng: centerPoint.lng }}
            icon={{
              url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png", // red marker icon
            }}
          />
        )}

        {selectedLocation && (
          <InfoWindow
            position={{
              lat: selectedLocation?.latitude || selectedLocation.lat,
              lng: selectedLocation?.longitude || selectedLocation.lng,
            }}
            options={{
              disableAutoPan: true, // Prevent map from auto-panning to the InfoWindow
            }}
            onCloseClick={() => setSelectedLocation(null)}
          >
            <div>
              <InfoWindowContent
                data={selectedLocation}
                setSelectedLocation={setSelectedLocation}
              />
            </div>
          </InfoWindow>
        )}
      </GoogleMap>

      {/* Inject styles to hide the close button */}
      <style>
        {`
          .gm-ui-hover-effect {
            display: none !important; /* Hide the close button */
          }
          .gm-style-iw-d {
            padding: 0 !important; /* Remove padding from the InfoWindow content */
          }
        `}
      </style>
    </>
  );
};

export default DynamicMap;
